import dayjs, { Dayjs } from 'dayjs';

export const generateDateRows = (forDate: number) => {
  const date = dayjs.unix(forDate);
  const year = date.year();
  const daysInMonth = date.daysInMonth();
  const rows: Dayjs[][] = [[]];
  let rowIndex: number = 0;

  // fill in initial rows
  [...Array(daysInMonth)].map((_, index: number) => {
    const monthDate = dayjs(new Date(year, date.month(), index + 1));
    const dayOfWeek = monthDate.day();

    rows[rowIndex].push(monthDate);

    if (dayOfWeek === 6 && index !== daysInMonth - 1) {
      rowIndex += 1;
      rows.push([]);
    }
  });

  const firstRow = rows[0];

  // backfill days from prev month in first week of month
  if (firstRow.length !== 7) {
    const backfillBy = 7 - firstRow.length;
    const first = firstRow[0];

    [...Array(backfillBy)].map((_, index: number) => {
      const d = first.clone().startOf('week').add(index, 'day');
      firstRow.splice(index, 0, d);
    });
  }

  // frontfill days from next month in last week of month
  const lastRow = rows[rows.length - 1];
  if (lastRow.length !== 7) {
    const fillBy = 7 - lastRow.length;
    const lastLen = lastRow.length;
    const last = lastRow[lastLen - 1];

    [...Array(fillBy)].map((_, index: number) => {
      const day = last.clone().add(index + 1, 'day');
      lastRow.push(day);
    });
  }

  return rows;
};
